var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalRubleWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#E8344A;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 500,
    cy: 500,
    r: 500
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M725.4901733,274.5097961C665.3594971,214.3790741,585.6209106,181.0457611,500,181.0457611 s-165.3594666,33.333313-225.4902039,93.464035S181.0457611,414.3790894,181.0457611,500 c0,84.9673462,33.333313,165.3594971,93.464035,225.4901733C334.6405334,785.6209106,414.3790894,818.9542847,500,818.9542847 s165.3594971-33.333313,225.4901733-93.4641113C785.6209106,665.3594971,818.9542847,585.6209106,818.9542847,500 C818.3006592,415.0326843,785.6209106,334.6405334,725.4901733,274.5097961z M339.2156982,267.320282v203.2679443H218.9542542 C227.4509735,386.9281006,273.2026062,313.7254944,339.2156982,267.320282z M339.2156982,586.9281006H230.7189484 c-5.8823395-18.3006592-9.8039246-37.9085083-11.7646942-57.5163574h120.2614441V586.9281006z M257.5163574,645.0980225h81.6993408 v87.5817261C305.8823547,709.803894,278.431366,679.7385864,257.5163574,645.0980225z M500,782.3529053 c-36.6012878,0-71.2418518-6.5359497-102.6143799-19.6078491V645.0980225h132.026123v-58.1699219h-132.026123v-57.5163574 h78.4313965c128.7581177,0,184.3137207-66.013031,184.3137207-146.4052124 c0-77.124176-45.0980835-145.098053-184.3137207-145.098053l-83.6601562,0.6536102 C425.4901733,224.8366089,462.0914917,216.9934692,500,216.9934692c156.2091675,0,282.3529053,126.7973633,282.3529053,282.3529358 S656.2091675,782.3529053,500,782.3529053z M397.3856201,471.2418213V296.7320251l81.6993713-0.6535645 c79.7385559,0,114.3790588,32.679718,114.3790588,88.888855c0,56.8627319-39.8692627,86.2745056-119.6078491,86.2745056 H397.3856201z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalRubleWhiteLogo);
export default __webpack_public_path__ + "static/media/digital-ruble-white-logo.8b88f4e1f2bf4ccd739937d7339a2cfa.svg";
export { ForwardRef as ReactComponent };